import React from 'react';
import { motion } from 'framer-motion';
import { BeforeAfterSlider } from './BeforeAfterSlider';
export function BeforeAfter() {
  const comparisons = [{
    before: 'https://cdn.magicpatterns.com/uploads/gpsQzVVnLgxe5jrfC6jJPn/phoenix-tree-trim.png',
    after: 'https://cdn.magicpatterns.com/uploads/ojJTzsoACRPfGAhZu8Yqoz/phoenix-tree-trim-after.png',
    caption: 'Mesquite trimmed for storm season, weight removed, shape restored'
  }, {
    before: 'https://cdn.magicpatterns.com/uploads/3e3XSGD1PmH12jjRQ54ych/phoenix-tree-before.png',
    after: 'https://cdn.magicpatterns.com/uploads/iskBute6KRQc7FCN9jrjzE/phoenix-tree-after.png',
    caption: 'Olive tree pruned for safety and shape, canopy opened up'
  }];
  return <section className="w-full bg-gradient-to-b from-brand-brown/20 to-brand-bg py-16 md:py-24" data-id="element-10">
      <div className="container mx-auto px-6" data-id="element-11">
        <motion.h2 initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="font-display text-3xl md:text-5xl text-white text-center mb-12 md:mb-16" data-id="element-12">
          See the Difference
        </motion.h2>

        <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 md:gap-12" data-id="element-13">
          {comparisons.map((comparison, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: index * 0.2
        }} data-id="element-14">
              <BeforeAfterSlider beforeImage={comparison.before} afterImage={comparison.after} caption={comparison.caption} data-id="element-15" />
            </motion.div>)}
        </div>
      </div>
    </section>;
}